import { IStateInitialState } from "../../../types/master/stateInterface";
import { StateActionTypes, StateActions } from "../../actionTypes/master/stateActionTypes";

const initialState: IStateInitialState = {
  stateList: [],
  stateData: {
    id: 0,
    state_name: "",
    slug: "",
  },
  stateListPageCount: 0,
};

export default function stateReducer(state = initialState, action: StateActionTypes): IStateInitialState {
  switch (action.type) {
    case StateActions.SET_STATE_LIST:
      return {
        ...state,
        stateList: action.payload,
      };

    case StateActions.SET_STATE_LIST_PAGE_COUNT:
      return {
        ...state,
        stateListPageCount: action.payload,
      };

    case StateActions.SET_STATE_DATA_BY_ID:
      return {
        ...state,
        stateData: action.payload,
      };

    default:
      return state;
  }
}
